import React from "react";
import { useI18n } from "@/lib/i18n";

const CITIES = ["Київ","Харків","Одеса","Львів","Дніпро","Запоріжжя","Полтава","Вінниця","Черкаси","Суми","Миколаїв","Херсон"];

export default function Geography() {
  const { t } = useI18n();
  return (
    <section data-testid="geo-section" className="relative bg-onyx py-24 lg:py-32 overflow-hidden">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-12 gap-10 items-end mb-12">
          <div className="col-span-12 lg:col-span-7">
            <div className="eyebrow mb-6 flex items-center gap-3">
              <span className="w-8 h-px bg-brass" /> {t.geo.eyebrow}
            </div>
            <h2 className="font-display text-[2.4rem] sm:text-5xl lg:text-6xl text-bone leading-[1] tracking-tight">
              {t.geo.title_1} <span className="italic-display text-brass">{t.geo.title_2}</span>
            </h2>
          </div>
          <div className="col-span-12 lg:col-span-4 lg:col-start-9">
            <p className="text-bone/70 leading-relaxed">{t.geo.lead}</p>
          </div>
        </div>

        {/* Marquee of cities */}
        <div className="relative overflow-hidden border-y border-bone/10 py-8">
          <div className="marquee-track animate-marquee whitespace-nowrap">
            {[...CITIES, ...CITIES].map((c, i) => (
              <span key={i} className="font-display text-4xl lg:text-6xl text-bone/85 mr-12 lg:mr-20">
                {c} <span className="text-brass">·</span>
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
